import auth from './auth.js';

export class ApiError extends Error {
  constructor(status, detail) { super(detail); this.status = status; }
}
export class NetworkError extends Error {}

async function token() {
  try { return await auth.getIdToken(); } catch { return null; }
}

export async function api(method, path, body) {
  let res;
  try {
    const tk = await token();
    res = await fetch(path, {
      method,
      headers: { ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}), ...(tk ? { Authorization: `Bearer ${tk}` } : {}) },
      body: body !== undefined ? JSON.stringify(body) : undefined,
    });
  } catch (e) {
    throw new NetworkError(e.message);
  }
  if (res.status === 401) {
    // token may be stale: retry once with a forced refresh
    const tk = await auth.getIdToken(true).catch(() => null);
    if (tk) {
      res = await fetch(path, {
        method,
        headers: { ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}), Authorization: `Bearer ${tk}` },
        body: body !== undefined ? JSON.stringify(body) : undefined,
      }).catch((e) => { throw new NetworkError(e.message); });
    }
  }
  if (res.status === 204) return null;
  const ct = res.headers.get('content-type') || '';
  const data = ct.includes('json') ? await res.json() : await res.text();
  if (!res.ok) {
    const detail = typeof data === 'object' && data ? (typeof data.detail === 'string' ? data.detail : 'Request failed') : String(data);
    throw new ApiError(res.status, detail);
  }
  return data;
}
export const get = (p) => api('GET', p);
export const post = (p, b = {}) => api('POST', p, b);
export const put = (p, b = {}) => api('PUT', p, b);
export const patch = (p, b = {}) => api('PATCH', p, b);
export const del = (p) => api('DELETE', p);

/** Download an authenticated file (CSV) via blob. */
export async function download(path, filename) {
  const tk = await token();
  const res = await fetch(path, { headers: tk ? { Authorization: `Bearer ${tk}` } : {} });
  if (!res.ok) throw new ApiError(res.status, 'Download failed');
  const url = URL.createObjectURL(await res.blob());
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
